import { el } from 'redom';

import HelptapColorPicker from 'generics/components/color-picker-native';

import {
  displayElementAroundAnchor
} from 'utilities/element-position';

class ColorPickerPanel {

  constructor(configuration) {

    this.configuration = configuration;
    this.picker = new HelptapColorPicker({
      color: this.configuration.color,
      onChange: this.configuration.onChange,
      onClose: this.configuration.onClose
    });

    this.el = el('.color-picker-panel', [this.picker]);

  }

  onmount() {

    const element = this.el;
    const anchorElement = this.configuration.anchor;
    const viewportElement = void 0;
    const verticalOffset = 5;
    const horizontalOffset = 5;
    const startSide = 'top';
    const placeOnCenter = true;
    const positionableSides = ['top', 'bottom'];

    displayElementAroundAnchor(element, anchorElement, viewportElement, verticalOffset, horizontalOffset, startSide, placeOnCenter, positionableSides);

  }

}

export default ColorPickerPanel;